import * as React from 'react';
import isSuggestedRepliesOptionDirty from '../utils/isSuggestedRepliesOptionDirty';
import SuggestedRepliesFull from './SuggestedRepliesFull';
import { discardAction, saveAction } from '../data/actions/suggestedRepliesOptionActions';
import { Option } from 'owa-options-core';

const SuggestedRepliesOption: Option = {
    key: 'SuggestedReplies',
    titleStringKey: 'optionTitle_suggestedReplies',
    searchTermsStringKey: 'optionTitle_suggestedReplies',
    fullOptionFormSettings: {
        render: () => <SuggestedRepliesFull />,
        isDirty: isSuggestedRepliesOptionDirty,
        onSave: async () => {
            saveAction();
        },
        onDiscard: () => {
            discardAction();
        },
    },
};

export default SuggestedRepliesOption;
